import { Helpers } from '../../helpers';
import { IWaterNetwork } from '../../interfaces/iwater-network';
import { Area } from '../area';
import { WaterSubNetwork } from '../water-sub-network';

export class WaterNetworkBase {
  WaterNetworkId: number;
  MaximumCapacity: number | null;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Areas_WaterNetwork?: Array<Area> | null;
  WaterSubNetworks_WaterNetwork?: Array<WaterSubNetwork> | null;

  constructor(item?: IWaterNetwork) {
    if (item) {

      this.WaterNetworkId = item.WaterNetworkId;
      this.MaximumCapacity = item.MaximumCapacity;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Areas_WaterNetwork = Helpers.createClassArray(Area, item.Areas_WaterNetwork);
      this.WaterSubNetworks_WaterNetwork = Helpers.createClassArray(WaterSubNetwork, item.WaterSubNetworks_WaterNetwork);
    }
  }
}